import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { t } from '@/lib/i18n';
import { useConnectors, useDisconnectConnector } from '../hooks';
import { ConnectorCard } from './ConnectorCard';
import { ConnectorConnectModal } from './ConnectorConnectModal';
import { ConnectorGrantsModal } from './ConnectorGrantsModal';
import styles from './ConnectorsSection.module.css';

export function ConnectorsSection() {
  const { data, isLoading } = useConnectors();
  const disconnect = useDisconnectConnector();
  const [connectTarget, setConnectTarget] = useState<string | null>(null);
  const [grantsTarget, setGrantsTarget] = useState<string | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const connected = searchParams.get('connectorConnected');
    const error = searchParams.get('connectorError');
    if (connected || error) {
      setSearchParams((p) => {
        p.delete('connectorConnected');
        p.delete('connectorError');
        return p;
      });
    }
  }, [searchParams, setSearchParams]);

  const connectingConnector = data?.connectors.find((c) => c.id === connectTarget) ?? null;
  const grantsConnector = data?.connectors.find((c) => c.id === grantsTarget) ?? null;

  return (
    <section className={styles.section}>
      <h2 className={styles.heading}>{t('Connectors')}</h2>
      <p className={styles.subtitle}>
        {t('Connect external services to give your AI Members access to real data and tools.')}
      </p>

      {isLoading && <p className={styles.loading}>{t('Loading connectors…')}</p>}

      <div className={styles.grid}>
        {(data?.connectors ?? []).map((c) => (
          <ConnectorCard
            key={c.id}
            connector={c}
            onConnect={setConnectTarget}
            onDisconnect={(id) => disconnect.mutate(id)}
            onManageGrants={setGrantsTarget}
          />
        ))}
      </div>

      <ConnectorConnectModal
        connector={connectingConnector}
        onClose={() => setConnectTarget(null)}
      />

      <ConnectorGrantsModal
        connectorId={grantsTarget}
        connectorName={grantsConnector?.name ?? ''}
        onClose={() => setGrantsTarget(null)}
      />
    </section>
  );
}
